import React from 'react'
import copy from 'copy-to-clipboard'

import { Dropdown } from '@sketch/components'

import { routes } from '@sketch/modules-common'
import { useToast } from '@sketch/toasts'

type ShareLinkProps = {
  shareIdentifier: string
  frameUUID?: string
  publicationIdentifier?: never
  shortUrlName?: never
}

type PublicationLinkProps = {
  shareIdentifier?: never
  frameUUID?: never
  publicationIdentifier: string
  shortUrlName: string
}

type CopyLinkProps = ShareLinkProps | PublicationLinkProps

const CopyLink: React.FC<CopyLinkProps> = ({
  shareIdentifier: shareID,
  frameUUID,
  publicationIdentifier,
  shortUrlName,
}) => {
  const { showToast } = useToast()

  let routePath = null
  if (publicationIdentifier && shortUrlName) {
    routePath = routes.WORKSPACE_PROFILE_DOCUMENT.create({
      publicationId: publicationIdentifier,
      shortUrlName,
    })
  } else if (shareID && frameUUID) {
    routePath = routes.FRAME.create({
      shareID,
      frameUUID,
    })
  } else if (shareID) {
    routePath = routes.SHARE_VIEW.create({
      shareID,
    })
  }
  const link = `${window.location.origin}${routePath}`

  return (
    <Dropdown.Item
      onClick={() => {
        copy(link)
        showToast('Link copied')
      }}
    >
      Copy Link
    </Dropdown.Item>
  )
}

export default CopyLink
